import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import xlsx from 'xlsx';
export default {
  name: 'excelupdate',
  prop: {
    nerd: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      persons: [],
      fileList: [],
      val: ""
    };
  },
  computed: {},
  mounted: function mounted() {},
  created: function created() {},
  methods: {
    onsuccess: function onsuccess(file) {
      debugger;
    },
    change: function change(file) {
      var fileName = file.name.substring(file.name.lastIndexOf('.') + 1);
      var that = this;

      if (fileName != 'xls' && fileName != 'xlsx') {
        this.$refs.upload.clearFiles();
        this.$message({
          type: 'error',
          showClose: true,
          duration: 3000,
          message: '不是excel文件'
        });
      } else {
        that.val = file;
        var fileReader = new FileReader();

        fileReader.onload = function (ev) {
          console.log(ev, 'ev');

          try {
            var data = ev.target.result,
                workbook = xlsx.read(data, {
              type: 'binary'
            }),
                // 以二进制流方式读取得到整份excel表格对象
            persons = []; // 存储获取到的数据
          } catch (e) {
            console.log('文件类型不正确');
            return;
          } // 表格的表格范围，可用于判断表头是否数量是否正确


          var fromTo = ''; // 遍历每张表读取

          for (var sheet in workbook.Sheets) {
            if (workbook.Sheets.hasOwnProperty(sheet)) {
              fromTo = workbook.Sheets[sheet]['!ref'];
              persons = persons.concat(xlsx.utils.sheet_to_json(workbook.Sheets[sheet])); // break; // 如果只取第一张表，就取消注释这行
            }
          }

          that.deliver(persons);
        }; // 以二进制方式打开文件


        fileReader.readAsBinaryString(file.raw);
      }
    },
    deliver: function deliver(val) {// this.$emit('childByValue', val,this.val);
    }
  }
};